export default __webpack_public_path__ + "static/media/icon-sair.ebdc58aa.svg";